import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeUrl',
    standalone: true,
})
export class SanitizeUrlPipe implements PipeTransform {

    private _sanitizer: DomSanitizer = inject(DomSanitizer);

    transform(value: string): SafeResourceUrl {
        return this._sanitizer.bypassSecurityTrustResourceUrl(value);
    }
}